import { EmailService } from '../../api/emailService';
import { emailTemplates } from '../../utils/emailTemplates';

export interface EmailTemplate {
  subject: string;
  plaintext: string;
  html: string;
}

interface EmailProps {
  emailTemplate: EmailTemplate;
  toList: string[];
}

export const handleEmail = async (props: EmailProps, unAuthKey?: string) => {
  try {
    await EmailService.sendEmail(
      {
        from: 'help@unitybuildestimation.com',
        toList: props.toList,
        subject: props.emailTemplate.subject,
        plaintextcontent: props.emailTemplate.plaintext,
        htmlcontent: props.emailTemplate.html,
      },
      unAuthKey
    );

    return true;
  } catch (error) {
    console.error('Error sending email:', error);
    return false;
  }
};

export const sendVerificationEmail = async (
  email: string,
  name: string,
  code: string,
  unAuthKey?: string
): Promise<boolean> => {
  try {
    // Get the verification email template
    const verificationEmailTemplate = emailTemplates.verification(name, code);

    // Send the email with the unAuthKey
    const success = await handleEmail(
      {
        emailTemplate: verificationEmailTemplate,
        toList: [email],
      },
      unAuthKey
    );

    return success;
  } catch (error) {
    console.error('Error sending verification email:', error);
    return false;
  }
};
